export { SimpleNotificationsModule } from './src/simple-notifications.module';
export { SimpleNotificationsComponent } from './src/simple-notifications.component';
export { NotificationComponent } from './src/notification.component';
export { NotificationsService } from './src/notifications.service';
export { MaxPipe } from './src/max.pipe';

export { PushNotificationsModule } from './src/push-notifications.module';
export { PushNotificationsService } from './src/push-notifications.service';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./~/angular2-notifications/components.ts